import { user } from '@ohif/core';
import { AUTH_TOKEN_KEY } from '../constant';

export const validateEmail = email => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};
export const isUserLogedIn = () => {
  return Boolean(user.getAccessToken());
};

const parseJwt = token => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

export const isValidUser = () => {
  const userToken = sessionStorage.getItem('token') || localStorage.getItem('token');
  if (userToken) {
    const decodedJwt = parseJwt(userToken);
    if (decodedJwt.exp * 1000 < Date.now()) {
      // props.logOut();
      return false;
    }
  }
  else{
    return false;
  }

  return true;
}

export const removeUserCredentials = () => {
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
  sessionStorage.removeItem('role');
  sessionStorage.removeItem('name');
  sessionStorage.removeItem('hospitalId');
  sessionStorage.removeItem('hospitalName');
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem('role');
  localStorage.removeItem('name');
  localStorage.removeItem('hospitalId');
  localStorage.removeItem('hospitalName');
  sessionStorage.clear()
  localStorage.removeItem('isLightMode');
  localStorage.removeItem('selectedTheme');
  localStorage.removeItem('cloud_pacs_access_token');
  localStorage.removeItem('local_pacs_access_token');
};

export const getCloudPACSToken = () => {
 const cloudToken = sessionStorage.getItem('cloud_pacs_access_token') || localStorage.getItem('cloud_pacs_access_token');
 return cloudToken ? cloudToken : sessionStorage.getItem('shareDicomToken');
}

export const getLocalPACSToken = () => {
  return sessionStorage.getItem('local_pacs_access_token') || localStorage.getItem('local_pacs_access_token');
}

export function extractViewerTokensFromUrl(url) {
  const params = new URLSearchParams(url.split('?')[1]);

  const token = params.get("token");
  const dicomToken = params.get("dicomToken"); // aka pacsToken

  if (token && dicomToken) {
    return { token, pacsToken: dicomToken };
  }

  return null; // or throw an error if you want
}
